/** Category flags, supports bitwise masks */
export enum AssetCategory {
  none = 0,
  other = 1 << 0,
  bim = 1 << 1,
  pointcloud = 1 << 2,
  gis = 1 << 3,
  raster = 1 << 4,
  cad = 1 << 5,
  image = 1 << 6,
  pdf = 1 << 7,
  zip = 1 << 8,
  autodesk = 1 << 9,
  scanset = 1 << 10,
  layer = 1 << 11,
  all = ~(~0 << 12), //binary all 1s
}
